export const SEARCH_DIRECTIVES = {
	REGEX: "~",
	NOT: "!",
	EXACT: "$",
	LESS_THAN: "<",
	LESS_THAN_EQ: "<=",
	GREATER_THAN: ">",
	GREATER_THAN_EQ: ">=",
};
